let translationsAKEDV = {
	title: 'Favourites',
	subTitleNotLoggedIn: 'Some english text...',
	login: 'Login',
	registration: 'Registration',
	emptyList: 'Your favourite list is <strong> empty.</strong>',
	emptyListSubTitle: 'Some English text...',
	listCount: 'You have <strong> {{count}} </strong> favourite(s).',
	and: 'and',
	andAHalf: 'and a half',
	half: 'half',
	room: 'room',
	rooms: 'rooms',
	addComment: 'Add comment',
	addedComment: 'Added comment',
	addingDate: 'Adding date',
	comment: 'Comment',
	saveComment: 'Save comment',
	backToFavs: 'Back to favourites',
	soldNotification: 'This property is sold!',
	inactiveNotification: 'Inactive property!',
	becameCheaper: 'become cheaper',
	becameMoreExpensive: 'become more expensive',
	hasOffer: 'has offer',
	sold: 'sold',
	inactive: 'inactive',
	saveCount: 'save count',
	deleteComment: 'Delete comment',
	deleteCommentQuestion: 'Are you sure want to delete this comment?',
	deleteFavourite: 'Delete favourite',
	deleteFavouriteQuestion: 'Are you sure want to delete this property from favourites?',
	successDelete: 'Delete was successful',
	deleteAll: 'Delete all',
	deleteAllQuestion: 'Are you sure want to delete all of your favourites?',
	soldEstates: 'Sold properties',
	deleteAllButtonText: 'Delete all',
	newSearchButtonText: 'New search',
	compareButtonText: 'Compare'
};

export default translationsAKEDV;
